// actionTypes.js
import {
	FETCH_SURVEYS_WITH_DETAILS_REQUEST,
	FETCH_SURVEYS_WITH_DETAILS_SUCCESS,
	FETCH_SURVEYS_WITH_DETAILS_FAILURE,
} from '../../actions/actionTypes' // Corrected path

const initialState = {
	data: [],
	loading: false,
	error: null,
}

const surveyReportReducer = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_SURVEYS_WITH_DETAILS_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
			}
		case FETCH_SURVEYS_WITH_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload, // Make sure this matches the structure of your API response
			}
		case FETCH_SURVEYS_WITH_DETAILS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			}
		default:
			return state
	}
}

export default surveyReportReducer
